import React from "react"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { recipeComponentTypeOptions } from "../../utils/recipes"

const ComponentTypeSelect = (props) => {
    const { classes, ...otherProps } = props

    return (
        <FormControl className={classes.componentTypeFormControl} variant="standard">
            <InputLabel>Typologie des plats du jour</InputLabel>
            <Select
                variant="standard"
                name="componentType"
                label="Typologie des plats du jour"
                id="componentType"
                fullWidth
                {...otherProps}
            >
                {recipeComponentTypeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default ComponentTypeSelect
